<ng-template #acceptRejectModal let-modal>
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-support-ticket-close-confirmation-modal" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <div class="row align-items-center">
          <div class="mb-3">
            <label for="selectUser" class="form-label">
              @if(mode == UserType.DRIVER){
                {{ "label-title.driver" | translate }}
              }@else if(mode == UserType.PICKER){
                {{ "label-title.picker" | translate }}
              }
              <em class="ri-information-line info-icon text-secondary font-weight-medium" appClickHoverTooltip="select-driver-for"></em>
            </label>
            <ng-select
              id="selectUser"
              appearance="outline"
              #agreeSelect
              labelForId="selectUser"
              placeholder="{{ 'label-title.select-driver' | translate }}"
              [searchable]="true"
              [clearable]="false"
              [(ngModel)]="selectedUser"
              (change)="onSelectUser($event)"
              [items]="userList"
              bindLabel="fullName"
            >
            </ng-select>
          </div>
          @if(!selectedUser &&showValidationMessage){
          <div class="invalid-message">
            @if(mode == UserType.DRIVER){
              <p class="m-0">{{ "label-title.driver" | translate }} {{ "label-title.is-required" | translate }}</p>
            }@else if(mode == UserType.PICKER){
              <p class="m-0">{{ "label-title.picker" | translate }} {{ "label-title.is-required" | translate }}</p>
            }
          </div>
          }
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="acceptBtn" data-bs-dismiss="modal" (click)="userAccept()">{{ "button-title.accept" | translate }}</button>
        <button type="button" class="btn btn-primary" id="rejectBtn" data-bs-dismiss="modal" (click)="userReject()">{{ "button-title.reject" | translate }}</button>
      </div>
    </div>
  </ng-template>
  